// src/CustomTick.js
import React from 'react';

const CustomTick = ({ x, y, payload }) => {
  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dy={16} textAnchor="end" fill="#fff" fontWeight="bold" transform="rotate(-35)">
        {new Date(payload.value).toLocaleDateString()}
      </text>
    </g>
  );
};

export default CustomTick;
